import { ApplicationState } from 'app/types-store';
import { CaseState } from 'app/area/case/types-store';
import * as caseData from 'app/area/case/case-data-model';

export interface AttachLinkContainerProps {  
  initialValues: {[indexer: string]: any};
}

export const attachLinkValues = (state: CaseState, uiEngineProps: any, fullState: ApplicationState ) => {
  
    return {      
      valueFormatter: (title: string, linkUrl: string) => ({
          [(caseData.columnName[caseData.tableName.link] as any).title]: [{ value: title }],
          [(caseData.columnName[caseData.tableName.link] as any).linkUrl]: [{ value: linkUrl }]          
      })
    };     
};
